<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="grid gap-4 rounded-lais border border-lais-border bg-white p-5">
    <div class="h-[200px] animate-pulse rounded-lais bg-lais-bg-muted" />
    <div class="h-5 w-2/3 animate-pulse rounded bg-lais-bg-muted" />
    <div class="h-4 w-1/2 animate-pulse rounded bg-lais-bg-muted" />
    <div class="grid gap-2">
      <div class="h-4 w-full animate-pulse rounded bg-lais-bg-muted" />
      <div class="h-4 w-5/6 animate-pulse rounded bg-lais-bg-muted" />
    </div>
    <div class="h-11 animate-pulse rounded-lais bg-lais-bg-muted" />
  </div>
</template>
